module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[33]32.6d80d1f.woff2";